"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Baobab_Context_1 = require("../Baobab/Baobab-Context");
var errors_1 = require("../helpers/errors");
function useBaobab(nodeData) {
    var context = React.useContext(Baobab_Context_1.BaobabContext);
    var baobabNodeRef = React.useRef({
        logEvent: function () { return function () { return void 0; }; },
        startCreate: false,
    });
    var extendedNodeData = React.useMemo(function () {
        if (!context)
            return;
        var logger = context.logger, parentNode = context.parentNode;
        var node = parentNode ?
            logger.prepareChild(parentNode, nodeData) :
            logger.prepareRoot(nodeData);
        var baobabNode = baobabNodeRef.current;
        baobabNode.startCreate = true;
        baobabNode.nextContext = __assign(__assign({}, context), { parentNode: node });
        baobabNode.node = node;
        baobabNode.logEvent = function (eventDeclaration, eventArgs, props) {
            if (!baobabNode.node || !baobabNode.nextContext)
                return function () { return void 0; };
            var node = baobabNode.node;
            var logger = baobabNode.nextContext.logger;
            var baobabEvent = logger.createEvent(node, eventDeclaration, eventArgs, props);
            var withEvent = logger.withEvent.bind(logger, baobabEvent);
            withEvent(function (resolve) { return setTimeout(resolve, 0); });
            logger.dispatchEvent(node, baobabEvent);
            return withEvent;
        };
        return node;
    }, [context, nodeData]);
    React.useEffect(function () {
        var baobabNode = baobabNodeRef.current;
        if (!baobabNode.startCreate)
            return;
        if (!context || !extendedNodeData)
            throw new errors_1.BaobabNotInitError();
        context.logger.attachNode(extendedNodeData);
        baobabNode.startCreate = false;
        extendedNodeData.__useBaobab = true;
        return function () { return context.logger.detachNode(extendedNodeData); };
    }, [context, nodeData, extendedNodeData]);
    return React.useMemo(function () {
        var _a = baobabNodeRef.current, logEvent = _a.logEvent, nextContext = _a.nextContext, node = _a.node;
        var BaobabNode = {
            logEvent: logEvent,
            nextContext: nextContext,
            node: node,
        };
        return BaobabNode;
    }, []);
}
exports.useBaobab = useBaobab;
